import { useBettingData } from '@/common/hooks/bet/context/BettingDataContext';

import clsx from 'clsx';
import BetItem from '../BetItem';
import OrderStatusIcon from '../OrderStatusIcon';

const OrdersPanelSingle = () => {
  const { betOrders, totalOrdersStatus } = useBettingData();

  return (
    <div
      data-desc="h5/pc单关订单面板"
      className={clsx(
        'flex-1-col-hidden',
        `[--status-color:${totalOrdersStatus.statusColor}]`,
        '[background:linear-gradient(var(--status-color),var(--status-color))_no-repeat_center_top/100%_4px,var(--Background-300)]',
        'rounded-t-10px',
      )}
    >
      <div className="flex items-center justify-center pt-20px pb-12px">
        <div
          className={clsx(
            '_tf[16] font-500 leading-[1.5] text-[var(--status-color)]',
            'flex items-center gap-4px',
          )}
        >
          <OrderStatusIcon orderStatus={totalOrdersStatus.status} />
          <span>{totalOrdersStatus.text.replace('全部', '')}</span>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        {betOrders.map((order) => {
          const detail = order.orderDetails[0];
          return detail ? (
            <div key={order.orderId}>
              <BetItem betItem={detail} />
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};

export default OrdersPanelSingle;
